import { ScrollReveal } from "./ScrollReveal";
import { motion } from "framer-motion";
import { CheckCircle, Zap, Shield } from "lucide-react";

const pills = [
  { icon: Shield, label: "Verified Properties" },
  { icon: Zap, label: "Fast Listings" },
  { icon: CheckCircle, label: "Faster Deals" },
];

const ProductivitySection = () => (
  <section className="section-white py-20 sm:py-28">
    <div className="container mx-auto px-4 sm:px-6">
      <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-center max-w-4xl mx-auto">
        <ScrollReveal>
          <div>
            <p className="text-xs font-medium uppercase tracking-[0.15em] text-muted-foreground mb-3">
              Productivity
            </p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 text-foreground">
              Improve Your Team{" "}
              <span className="gradient-text font-extrabold">Productivity</span>
            </h2>
            <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
              Empower your team with tools that make closing deals faster. From
              discovery to completion, everything is streamlined.
            </p>

            <div className="flex flex-wrap gap-2 mb-6">
              {pills.map((pill, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: -16 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.12 }}
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary/[0.06] border border-primary/10 text-xs font-medium text-foreground"
                >
                  <pill.icon className="w-3.5 h-3.5 text-primary" />
                  {pill.label}
                </motion.div>
              ))}
            </div>

            <p className="text-xs text-muted-foreground/70 italic leading-relaxed">
              "Our team closes 3x more deals per month since switching to
              PRObroker."
            </p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.15}>
          <div className="rounded-2xl border border-border bg-background p-4 shadow-sm">
            <div className="flex items-center gap-1.5 mb-3">
              <div className="w-2.5 h-2.5 rounded-full bg-red-400/50" />
              <div className="w-2.5 h-2.5 rounded-full bg-amber-400/50" />
              <div className="w-2.5 h-2.5 rounded-full bg-emerald-400/50" />
              <div className="flex-1 h-4 rounded bg-muted/60 mx-6" />
            </div>
            <div className="grid grid-cols-3 gap-2.5 mb-3">
              {[
                { label: "Active Deals", value: "24" },
                { label: "Leads Today", value: "12" },
                { label: "Revenue", value: "₹4.2L" },
              ].map((item, i) => (
                <div
                  key={i}
                  className="p-3 rounded-xl bg-card border border-border text-center"
                >
                  <p className="text-base font-bold text-foreground">
                    {item.value}
                  </p>
                  <p className="text-[9px] text-muted-foreground mt-0.5">
                    {item.label}
                  </p>
                </div>
              ))}
            </div>
            <div className="space-y-2">
              {[72, 52, 88, 38].map((w, i) => (
                <div key={i} className="flex items-center gap-2.5">
                  <div className="w-7 h-7 rounded-lg bg-primary/[0.06]" />
                  <div className="flex-1">
                    <div
                      className="h-2 rounded-full bg-muted mb-1"
                      style={{ width: `${w}%` }}
                    />
                    <div className="h-1.5 rounded-full bg-muted/40 w-12" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </ScrollReveal>
      </div>
    </div>
  </section>
);

export default ProductivitySection;
